import { render } from "./BestBadgeComponent.vue?vue&type=template&id=558e7718&scoped=true"
import script from "./BestBadgeComponent.vue?vue&type=script&lang=js"
export * from "./BestBadgeComponent.vue?vue&type=script&lang=js"

import "./BestBadgeComponent.vue?vue&type=style&index=0&id=558e7718&scoped=true&lang=css"

import exportComponent from "/home/user/devops/sourcecode/Sopecam/sopecam-cameroontribune-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558e7718"]])

export default __exports__